import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { TOKEN_KEY } from '@/storage/constants'
import { getDataFromStorage } from '@/storage/storageRepository'

const getRawBaseQuery = ({ baseUrl = '' }) =>
  fetchBaseQuery({
    baseUrl: baseUrl || process.env.API_BASE_URL,
    prepareHeaders: async (headers) => {
      const token = getDataFromStorage(TOKEN_KEY)
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }

      return headers
    },
  })

const dynamicBaseQuery = async (
  args,
  api,
  extraOptions = {
    removeAdminPath: false,
    publicEndpoint: false,
    co2Endpoint: false,
  }
) => {
  const adjustedUrl = `${process.env.API_BASE_URL}${typeof args === 'string' ? args : args.url}`
  const adjustedArgs =
    typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl }
  const query = getRawBaseQuery({
    baseUrl: adjustedUrl,
  })(adjustedArgs, api, extraOptions)
  return query
}

export const sliceApi = createApi({
  reducerPath: 'api',
  endpoints: () => ({}),
  baseQuery: dynamicBaseQuery,
})
